import React from 'react';

const EmptyListIcon = (props: any) => (
  <svg width="146" height="146" viewBox="0 0 146 146" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="73" cy="65" r="39.195" stroke="#F1E7FF" stroke-width="11.61" />
    <g filter="url(#filter0_d_2381_119066)">
      <rect x="57" y="8" width="32" height="32" rx="16" fill="white" shapeRendering="crispEdges" />
      <path
        opacity="0.7"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.8812 23.9515C75.947 23.4456 76.6823 22.3725 76.6823 21.1304C76.6823 19.4015 75.2577 18 73.5003 18C71.7429 18 70.3183 19.4015 70.3183 21.1304C70.3183 22.3724 71.0535 23.4455 72.1191 23.9514C70.3094 24.5248 69 26.195 69 28.1661C69 30.6112 78 30.6112 78 28.1661C78 26.1952 76.6908 24.525 74.8812 23.9515Z"
        fill="#D1BAEF"
      />
      <rect
        x="57.75"
        y="8.75"
        width="30.5"
        height="30.5"
        rx="15.25"
        stroke="url(#paint0_radial_2381_119066)"
        strokeWidth="1.5"
        shapeRendering="crispEdges"
      />
      <rect
        x="57.75"
        y="8.75"
        width="30.5"
        height="30.5"
        rx="15.25"
        stroke="url(#paint1_radial_2381_119066)"
        strokeWidth="1.5"
        shapeRendering="crispEdges"
      />
    </g>
    <g filter="url(#filter1_d_2381_119066)">
      <rect x="57" y="90" width="32" height="32" rx="16" fill="white" shapeRendering="crispEdges" />
      <path
        opacity="0.7"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.8812 105.951C75.947 105.446 76.6823 104.373 76.6823 103.13C76.6823 101.402 75.2577 100 73.5003 100C71.7429 100 70.3183 101.402 70.3183 103.13C70.3183 104.372 71.0535 105.445 72.1191 105.951C70.3094 106.525 69 108.195 69 110.166C69 112.611 78 112.611 78 110.166C78 108.195 76.6908 106.525 74.8812 105.951Z"
        fill="#D1BAEF"
      />
      <rect
        x="57.75"
        y="90.75"
        width="30.5"
        height="30.5"
        rx="15.25"
        stroke="url(#paint2_radial_2381_119066)"
        strokeWidth="1.5"
        shapeRendering="crispEdges"
      />
      <rect
        x="57.75"
        y="90.75"
        width="30.5"
        height="30.5"
        rx="15.25"
        stroke="url(#paint3_radial_2381_119066)"
        strokeWidth="1.5"
        shapeRendering="crispEdges"
      />
    </g>
    <g filter="url(#filter2_d_2381_119066)">
      <rect x="98" y="50" width="32" height="32" rx="16" fill="white" shapeRendering="crispEdges" />
      <path
        opacity="0.7"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M115.881 65.9515C116.947 65.4456 117.682 64.3725 117.682 63.1304C117.682 61.4015 116.258 60 114.5 60C112.743 60 111.318 61.4015 111.318 63.1304C111.318 64.3724 112.054 65.4455 113.119 65.9514C111.309 66.5248 110 68.195 110 70.1661C110 72.6112 119 72.6112 119 70.1661C119 68.1952 117.691 66.525 115.881 65.9515Z"
        fill="#D1BAEF"
      />
      <rect
        x="98.75"
        y="50.75"
        width="30.5"
        height="30.5"
        rx="15.25"
        stroke="url(#paint4_radial_2381_119066)"
        strokeWidth="1.5"
        shapeRendering="crispEdges"
      />
      <rect
        x="98.75"
        y="50.75"
        width="30.5"
        height="30.5"
        rx="15.25"
        stroke="url(#paint5_radial_2381_119066)"
        strokeWidth="1.5"
        shapeRendering="crispEdges"
      />
    </g>
    <g filter="url(#filter3_d_2381_119066)">
      <rect x="16" y="50" width="32" height="32" rx="16" fill="white" shapeRendering="crispEdges" />
      <path
        opacity="0.7"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.8812 65.9515C34.947 65.4456 35.6823 64.3725 35.6823 63.1304C35.6823 61.4015 34.2577 60 32.5003 60C30.7429 60 29.3183 61.4015 29.3183 63.1304C29.3183 64.3724 30.0535 65.4455 31.1191 65.9514C29.3094 66.5248 28 68.195 28 70.1661C28 72.6112 37 72.6112 37 70.1661C37 68.1952 35.6908 66.525 33.8812 65.9515Z"
        fill="#D1BAEF"
      />
      <rect
        x="16.75"
        y="50.75"
        width="30.5"
        height="30.5"
        rx="15.25"
        stroke="url(#paint6_radial_2381_119066)"
        strokeWidth="1.5"
        shapeRendering="crispEdges"
      />
      <rect
        x="16.75"
        y="50.75"
        width="30.5"
        height="30.5"
        rx="15.25"
        stroke="url(#paint7_radial_2381_119066)"
        strokeWidth="1.5"
        shapeRendering="crispEdges"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_2381_119066"
        x="41.3537"
        y="0.176871"
        width="63.2925"
        height="63.2925"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="7.82313" />
        <feGaussianBlur stdDeviation="7.82313" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2381_119066" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2381_119066" result="shape" />
      </filter>
      <filter
        id="filter1_d_2381_119066"
        x="41.3537"
        y="82.1769"
        width="63.2925"
        height="63.2925"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="7.82313" />
        <feGaussianBlur stdDeviation="7.82313" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2381_119066" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2381_119066" result="shape" />
      </filter>
      <filter
        id="filter2_d_2381_119066"
        x="82.3537"
        y="42.1769"
        width="63.2925"
        height="63.2925"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="7.82313" />
        <feGaussianBlur stdDeviation="7.82313" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2381_119066" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2381_119066" result="shape" />
      </filter>
      <filter
        id="filter3_d_2381_119066"
        x="0.353742"
        y="42.1769"
        width="63.2925"
        height="63.2925"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="7.82313" />
        <feGaussianBlur stdDeviation="7.82313" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2381_119066" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2381_119066" result="shape" />
      </filter>
      <radialGradient
        id="paint0_radial_2381_119066"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(52.5984 4.04338) rotate(42.201) scale(34.7209 68.411)"
      >
        <stop stopColor="#E9D8FF" />
        <stop offset="0.910585" stopColor="#7C2FE2" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_2381_119066"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(91.6493 44.026) rotate(-133.066) scale(35.3456 64.4862)"
      >
        <stop stop-color="#7142AE" />
        <stop offset="0.859375" stopColor="#E7D5FF" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_2381_119066"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(52.5984 86.0434) rotate(42.201) scale(34.7209 68.411)"
      >
        <stop stop-color="#E9D8FF" />
        <stop offset="0.910585" stopColor="#7C2FE2" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_2381_119066"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(91.6493 126.026) rotate(-133.066) scale(35.3456 64.4862)"
      >
        <stop stop-color="#7142AE" />
        <stop offset="0.859375" stopColor="#E7D5FF" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_2381_119066"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(93.5984 46.0434) rotate(42.201) scale(34.7209 68.411)"
      >
        <stop stopColor="#E9D8FF" />
        <stop offset="0.910585" stopColor="#7C2FE2" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_2381_119066"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(132.649 86.026) rotate(-133.066) scale(35.3456 64.4862)"
      >
        <stop stop-color="#7142AE" />
        <stop offset="0.859375" stopColor="#E7D5FF" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_2381_119066"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(11.5984 46.0434) rotate(42.201) scale(34.7209 68.411)"
      >
        <stop stop-color="#E9D8FF" />
        <stop offset="0.910585" stopColor="#7C2FE2" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_2381_119066"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(50.6493 86.026) rotate(-133.066) scale(35.3456 64.4862)"
      >
        <stop stop-color="#7142AE" />
        <stop offset="0.859375" stopColor="#E7D5FF" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);

export default EmptyListIcon;
